import { type preferredTimeDisplayModeTypes } from 'types/customer.types';
import BaseAPI from './base.api';

export default class DriverBehaviourAPI extends BaseAPI {
  getAll = async (payload: {
    event?: string;
    events?: string[];
    range?: string;
    startDate?: string;
    endDate?: string;
    includeAllHaulTrucks?: boolean;
    showUnproductiveTrips?: boolean;
    average_fuel_key_to_use?: string;
  }) => {
    const { events, event, ...paramsFromPayload } = payload;
    const selectedEvents =
      events && events.length > 0 ? events : event ? [event] : [];
    const eventParams =
      selectedEvents.length === 1
        ? { event: selectedEvents[0] }
        : { events: selectedEvents };

    const response = await this.axiosInstance.request({
      method: 'GET',
      url: 'driver-event',
      params: {
        ...paramsFromPayload,
        ...eventParams,
      },
    });
    return response.data;
  };

  getAllWithPastComparision = async (payload: {
    event: string;
    range?: string;
    startDate?: string;
    endDate?: string;
  }) => {
    const response = await this.API.get(
      'driver-event/with-past-data-comparison',
      {
        params: {
          ...payload,
        },
      }
    );
    return response.data;
  };

  getGearCountMatrix = async (payload: {
    startDate?: string;
    endDate?: string;
  }) => {
    const response = await this.API.get('driver-event/gear-count-matrix', {
      params: {
        ...payload,
      },
    });
    return response.data;
  };

  getPolygonPoints = async () => {
    const response = await this.API.get('driver-event/polygon');
    return response.data;
  };

  getInclinometer = async (payload: {
    startDateTime: string;
    endDateTime: string;
    deviceId: string;
    assetId: string;
  }) => {
    const response = await this.API.post('inclinometer', payload);
    return response.data;
  };

  downloadEngineHoursTimelineReport = async (
    customerId: string,
    startDate: string,
    endDate: string,
    preferredTimeDisplayMode: preferredTimeDisplayModeTypes,
    clientTimezone: string,
    returnType: 'excel' | 'pdf',
    isSiteSummary: boolean = false
  ): Promise<ArrayBuffer> => {
    const resp = await this.API.get(
      '/analytics/fuel-analytics/reports/engine-hours-timeline',
      {
        params: {
          customerId,
          startDate,
          endDate,
          preferredTimeDisplayMode,
          clientTimezone,
          isSiteSummary,
        },
        responseType: 'arraybuffer',
        headers: {
          Accept:
            returnType === 'pdf'
              ? 'application/pdf'
              : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      }
    );
    return resp.data;
  };
}
